import { useEffect, useState } from 'react'
import { getNews } from '../lib/api'
import type { NewsItem } from '../lib/types'

export default function News() {
  const [news, setNews] = useState<NewsItem[]>([])
  const [loading, setLoading] = useState(true)
  const load = async () => { setLoading(true); try { setNews((await getNews()).news) } finally { setLoading(false) } }
  useEffect(() => { load() }, [])
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-white text-lg font-semibold">最新动态 <span className="text-muted text-sm font-normal">· {news.length} 条</span></h2>
        <button onClick={load} disabled={loading} className="text-muted text-sm hover:text-white disabled:opacity-50">{loading ? '刷新中...' : '↻ 刷新'}</button>
      </div>
      <div className="space-y-2">
        {news.map(n => (
          <a key={n.id} href={n.url || '#'} target="_blank" rel="noreferrer" className="block bg-card border border-border rounded-lg px-4 py-3 hover:border-blue transition">
            <div className="text-white text-sm mb-1.5">{n.title}</div>
            <div className="text-muted text-xs flex gap-2 flex-wrap">
              <span className="text-blue">{n.source}</span>
              <span>· {n.published?.slice(0, 10)}</span>
              {n.sector_id && <span className="text-teal">· {n.sector_id}</span>}
            </div>
          </a>
        ))}
        {!loading && news.length === 0 && <div className="text-muted py-12 text-center">暂无动态</div>}
      </div>
    </div>
  )
}
